export default __webpack_public_path__ + "static/Gotham-MediumItalic-4bd9292651b05df492f653e8dd1488f9.woff2";